export const ROUTE_BASE = '/dashboard';
export const GOPARROT_SUBDOMAIN = 'store.goparrot.ai';
